<template>
  <!--新编辑器 所有原地址都替换到这里 ，备注带有这个的地方：//替换新编辑器地址-1903 -->
  <div>
    <div class="com-Breadcrumb" style="padding: 0 20px">
      <el-breadcrumb separator=">">
        <el-breadcrumb-item
        ><a @click="gback()">模板管理</a></el-breadcrumb-item
        >
        <el-breadcrumb-item>新增模板</el-breadcrumb-item>
      </el-breadcrumb>
      <a class="r-btn" @click="gback()">返回上一步</a>
    </div>
    <el-container class="general">
      <div class="main" v-loading="loadingTpl">
<!--        <iframe ref="tipEditorRef2" style="width: 100%; height: calc(100vh - 100px)" src="http://127.0.0.1:9915/temEditor" frameborder="0"></iframe>-->
        <iframe ref="tipEditorRef2" style="width: 100%; height: calc(100vh - 100px)" :src="editorUrl" frameborder="0"></iframe>
      </div>
    </el-container>
  </div>
</template>

<script>

  import ElGo from "../../components/go/Go";
  import {ApiMethods} from "@/assets/js/http-serve/http-methods";
  const base64 = require('js-base64').Base64;
  import GlobalConfig from '../../assets/js/config/global';
  export default {
    name: "authEdit",
    components: {ElGo },
    // layout: "entconsolelayout",
    layout: "editorFullLayout",
    data() {
      return {
        tplResData: {},//编辑时
        // filter model
        filterModel: {
          targetId: "",
          itemPage: 1,
          pageSize: 10,
          pageTotal: 0,
          corpGroupId: ""
        },
        tableSetManager: [],
        memberGroups: [],
        selectApprovalorTableRow: [],
        selectApprovalorManagerValue: 1,
        corpUserIdSet: '',
        defaultChooseList: [],

        moveDeptSelect: [],
        departmentArray: [],
        defaultProps: {
          children: "childCorpGroups",
          label: "label"
        },
        treeGroupCopy: [],
        tplFrm: { tplId: "", tplName: "", serialNum: "" },
        visibleMoveOrg: false,
        tplFrmRules: {
          tplName: [
            { validator: this.$validator.required, message: "模板名称不能为空" },
            {
              validator: this.$validator.regex,
              regex: /^(?![\s])(?!.*[\s]$).*$/,
              trigger: "change",
              message: "变量名称前后不要留空白"
            },
            {
              validator: this.$validator.lengthRank,
              minLength: 2,
              maxLength: 30,
              trigger: "change"
            }
          ]
        },
        editTplVarDialogName: "新增模板变量",
        tplVarList: [],
        showEditTplVarDialog: false,
        currentOpVar: {},
        tplVarFrm: { varName: "", varType: 0, varIsMust: false },
        varTypeEnum: [
          {
            label: ""
          }
        ],
        tplVarFrmRules: {
          varName: [
            {
              validator: this.$validator.required,
              trigger: "change",
              message: "变量名称不能为空"
            },
            {
              validator: this.$validator.regex,
              regex: /^(?![\s])(?!.*[\s]$).*$/,
              trigger: "change",
              message: "变量名称前后不要留空白"
            },
            {
              validator: this.$validator.lengthRank,
              minLength: 2,
              maxLength: 30,
              trigger: "change"
            },
            {
              validator: (rule, val, callback) => {
                for (var key in this.tplVarList) {
                  if (
                    this.tplVarList[key].varName == val &&
                    this.currentOpVar.varName != val
                  ) {
                    return callback("变量名称不能重复");
                  }
                }
                callback();
              },
              trigger: "change"
            }
          ]
        },
        valChange: { name: "", oldName: "" },
        innerString: null,
        delInner: "",
        dragging: false,
        loadingTpl: false,
      };
    },
    computed: {
      editorUrl() {
        return GlobalConfig.domain.jzqTplEditor + '/temEditor'
      },
      currentAuthUser() {
        return this.$store.getters.currentAuthUser || {};
      },
      consoleToken() {
        return this.$store.getters.consoleToken
      },
      token () {
        return this.$store.getters.token
      }
    },
    mounted() {
      this.init();
      window.addEventListener('message', this.messageListener);
    },
    beforeDestroy() {
      window.removeEventListener('message', this.messageListener)
    },
    methods: {
      init() {
        let loading = this.$loading();
        let tplId = this.$route.query.tplId;
        if (tplId) {
          ApiMethods.TemplateController[this.currentAuthUser.userType === 0 ? 'findTpl' : 'cmListTplDetail']({ tplId: tplId })
            .then(result => {
              if (result.success) {
                setTimeout(() => {
                  this.tplResData = result.data;
                  this.parentPostMessageFn(result.data)
                  loading.close();
                }, 1000);
              } else {
                this.$message.error(result.description || "");
              }
            })
        } else {
          setTimeout(() => {
            this.parentPostMessageFn()
            loading.close();
          }, 1000);
        }
      },
      messageListener(message) {
        if (message.data.type === 'tipEditor_requestData') {
          console.log('request数据', message.data.content)
          this.submitFn(message.data.content);
        } else if (message.data.type === 'tipEditor_goBack') {
          this.$confirm('确定退出吗', "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(res => {
            this.$router.replace(this.currentAuthUser.corpUserId ? '/console/template' : '/tpl/general');
          })
        }
      },
      //提交
      submitFn(data) {
        let param = {
          ...this.tplResData,
          ...data,
          editorType: 1,
        }
        ApiMethods.TemplateController[this.currentAuthUser.userType === 0 ? 'operTpl' : 'cmOperTpl'](param).then(res => {
          if (res.success) {
            this.$message.success('操作成功')
            this.$router.back();
          }
        })
      },
      gback() {
        // this.$router.push({ path: "/console/setting?activeName=tab-template" });
        this.$router.push({
          path: "/console/template",
          query: { activeName: "mianSign" }
        });
      },
      //传token
      parentPostMessageFn(content) {
        const consoleTokenObj = this.consoleToken ? JSON.parse(base64.decode(this.consoleToken.token)) : {};
        const userTokenObj = this.token ? JSON.parse(base64.decode(this.token)) : {};
        let allToken = Object.assign({}, userTokenObj, consoleTokenObj);
        let token = base64.encode(JSON.stringify(allToken));
        this.$refs.tipEditorRef2.contentWindow.postMessage({
          type: 'tipEditor_parent',
          content: {
            ...content,
            token: token,
            individual: this.currentAuthUser.userType === 0,
          },
        }, '*')
      },
    }
  };
</script>

<style scoped lang="less">
  .general {
    padding: 20px 0;
    background: #fff;
    .main {
      width: 100%;
      padding: 0 20px 0 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// pages/authEdit/variableEditor.vue